module.exports = __webpack_public_path__ + "media/images/point/icon_points-20a3e3059298eddef2cdd992c180232f.svg";